module.exports = __webpack_public_path__ + "src/app/_content/imgs/mini/discover/ConnectedDrive.jpg?caa5a444172147dcfdb7a0ee13620da6";